<template>
  <el-form
    :model="hotsalesData"
    ref="hotsalesData"
    label-width="15%"
    class="demo-brandForm"
    v-loading.body="fetchLoding"
  >
    <el-form-item :label="generateCustomizeString('hotSalesTitle')" prop="title">
      <el-input v-model="hotsalesData.title" :placeholder="generateCustomizeString('hotSalesTitle')"></el-input>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('hotSalesImage')" prop="img_url">
      <el-upload
        action="https://upload-z2.qiniup.com"
        :limit="1"
        :drag="true"
        :on-success="handleAvatarSuccess"
        :on-error="handleError"
        :before-upload="beforeAvatarUpload"
        :data="qiniuData"
      >
        <img v-if="img_url" :src="displayHotSalesUrl" />
        <div v-else>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            {{generateCustomizeString('dragFiles')}}
            <em>{{generateCustomizeString('uploadFiles')}}</em>
          </div>
        </div>
        <div
          class="el-upload__tip"
          slot="tip"
        >{{generateCustomizeString('fileLimit')}}, {{generateCustomizeString('hotSalesImageSize')}}</div>
        <!-- <div class="el-upload__tip" slot="tip">{{generateCustomizeString('uploadFilesSize')}}</div> -->
      </el-upload>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('relatedTo')">
      <el-radio-group v-model="relatedTo" size="medium" @change="clearInput">
        <el-radio label="1" border>{{ generateCustomizeString('merchandiseCategories') }}</el-radio>
        <el-radio label="2" border>{{ generateCustomizeString('brand') }}</el-radio>
        <el-radio label="6" border>{{ generateCustomizeString('brandList') }}</el-radio>
        <el-radio label="3" border>{{ generateCustomizeString('searchPage') }}</el-radio>
        <el-radio label="4" border>{{ generateCustomizeString('activityUrl') }}</el-radio>
        <el-radio label="5" border>{{ generateCustomizeString('relatedCustomize') }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      :label="generateCustomizeString('relatedCategories')"
      v-if="this.relatedTo === '1'"
    >
      <el-cascader
        expand-trigger="hover"
        :options="categoriesOptions"
        v-model="selectedCategories"
        @change="handleCategoryChange"
        change-on-select
      ></el-cascader>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('relatedBrands')" v-if="this.relatedTo === '2'">
      <el-select
        v-model="brandId"
        filterable
        :placeholder="generateCustomizeString('productBrand')"
        @change="handleBrandChange"
      >
        <el-option
          v-for="item in brandOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('relatedSearch')" v-if="this.relatedTo === '3'">
      <el-input v-model="keyword"></el-input>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('relatedActivity')" v-if="this.relatedTo === '4'">
      <el-select
        v-model="activity"
        filterable
        :placeholder="generateCustomizeString('activityUrl')"
        @change="handleActivityChange"
      >
        <el-option
          v-for="item in activityOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      :label="generateCustomizeString('relatedCustomize')"
      v-if="this.relatedTo === '5'"
    >
      <el-input v-model="hotsalesData.mobile_action_url" placeholder="以 http:// 或 https:// 开头"></el-input>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('actionUrl')" prop="mobile_action_url">
      <el-input
        v-model="hotsalesData.mobile_action_url"
        :placeholder="generateCustomizeString('mobileActionUrl')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('pcActionUrl')" prop="pc_action_url">
      <el-input
        v-model="hotsalesData.pc_action_url"
        :placeholder="generateCustomizeString('pcActionUrl')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('sortWeight')" prop="order_weight">
      <el-input v-model="hotsalesData.order_weight" type="number"></el-input>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('bannerActivity')" prop="mobile_status">
      <el-switch v-model="hotsalesData.mobile_status"></el-switch>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('bannerPCActivity')" prop="pc_status">
      <el-switch v-model="hotsalesData.pc_status"></el-switch>
    </el-form-item>
    <el-form-item
      :label="generateCustomizeString('isAgentVisible')"
      prop="is_agent_visible"
      v-if="this.relatedTo === '5'"
    >
      <el-switch v-model="hotsalesData.is_agent_visible" disabled></el-switch>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('isAgentVisible')" prop="is_agent_visible" v-else>
      <el-switch v-model="hotsalesData.is_agent_visible"></el-switch>
    </el-form-item>
    <el-form-item>
      <el-button
        v-if="isEdit"
        type="primary"
        @click="submitForm('brandForm')"
        plain
      >{{generateCustomizeString('update')}}</el-button>
      <el-button
        v-if="!isEdit"
        type="primary"
        @click="submitForm('brandForm')"
      >{{generateCustomizeString('create')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

const defaultData = {
  title: '',
  img: '',
  mobile_action_url: '',
  mobile_status: false,
  pc_status: false,
  pc_action_url: '',
  is_agent_visible: true,
  order_weight: 0
}

export default {
  name: 'HotSalesDetail',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hotsalesData: Object.assign({}, defaultData),
      qiniuData: {
        token: ''
      },
      fetchLoding: false,
      categoriesOptions: [],
      brandOptions: [],
      img_url: '',
      categoryId: [],
      brandId: '',
      relatedTo: '',
      customize: '',
      activity: '',
      activityTitle: '',
      activityOptions: [
        {
          value: 'module/promote',
          label: '热门推荐',
          title: 'Recommending%20Products'
        },
        {
          value: 'module/time-special',
          label: '限时特价',
          title: 'Limited%20Time%20Special'
        },
        {
          value: 'module/newest',
          label: '最新上架',
          title: 'New%20Products'
        },
        {
          value: 'module/hot',
          label: '热销排行',
          title: 'Hot%20Products'
        }
      ]
    }
  },
  methods: {
    generateCustomizeString,
    handleCategoryChange() {
      this.hotsalesData.mobile_action_url = 'category/' + this.categoryId[0]
      this.hotsalesData.pc_action_url = 'category/' + this.categoryId[0]
    },
    handleBrandChange() {
      this.hotsalesData.mobile_action_url = 'brand/' + this.brandId
      this.hotsalesData.pc_action_url = 'brand/' + this.brandId
    },
    handleActivityChange() {
      for (let i = 0; i < this.activityOptions.length; i++) {
        if (this.activityOptions[i].value == this.activity) {
          this.activityTitle = this.activityOptions[i].title
        }
      }
      this.hotsalesData.mobile_action_url = 'product/list?actionUrl=' +
                                    this.activity.substring('module/'.length) +
                                    '&activityTitle=' + this.activityTitle
      this.hotsalesData.pc_action_url = 'product/list?actionUrl=' +
                                    this.activity.substring('module/'.length) +
                                    '&activityTitle=' + this.activityTitle
    },
    clearInput() {
      this.keyword = ''
      this.hotsalesData.mobile_action_url = ''
      this.hotsalesData.pc_action_url = ''
      if (this.relatedTo === '5') {
        this.hotsalesData.is_agent_visible = false
      } else if (this.relatedTo === '6') {
        this.hotsalesData.mobile_action_url = 'brandList'
        this.hotsalesData.pc_action_url = 'brandList'
      }
    },
    submitForm(formName) {
      if (this.isEdit) {
        // update
        this.updateHotSales()
      } else {
        // create
        this.createHotSales()
      }
    },
    fetchCategories() {
      return new Promise((resolve, reject) => {
        request({
          url: '/categories',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = parseInt(response.data[i].id)
              obj.label = response.data[i].name
              const sub = response.data[i].sub_categories
              for (let j = 0; j < response.data[i].sub_categories.length; j++) {
                var sobj = {}
                sobj.value = parseInt(response.data[i].sub_categories[j].id)
                sobj.label = response.data[i].sub_categories[j].name
                sub[j] = sobj
              }
              obj.children = sub
              data[i] = obj
            }
            this.categoriesOptions = data
            console.log(this.categoriesOptions)
            resolve()
          })
          .catch(error => {
            console.warn(error)
            reject(error)
          })
      })
    },
    fetchBrand() {
      return new Promise((resolve, reject) => {
        request({
          url: '/brands?pages=all',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].id
              obj.label = response.data[i].brand_name
              data[i] = obj
            }
            this.brandOptions = data
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchHotSales() {
      return new Promise((resolve, reject) => {
        request({
          url: 'hot-sales/' + this.$route.params.hotSalesId,
          method: 'get'
        })
          .then(res => {
            if (res.status === 0) {
              // 更新数据
              for (const i in this.hotsalesData) {
                this.hotsalesData[i] = res.data[i]

                if (i === 'status') {
                  this.hotsalesData.status = res.data[i] === 1
                }
                if (i === 'pc_status') {
                  this.hotsalesData.pc_status = res.data[i] === 1
                }
                if (i === 'is_agent_visible') {
                  this.hotsalesData.is_agent_visible = res.data[i] === 1
                }
              }
              console.log(this.hotsalesData)
              if (res.data['img_url']) {
                this.img_url = res.data['img_url']
              }

              if (res.data['mobile_action_url'].substring(0, 1) === 'c') {
                this.relatedTo = '1'
                this.categoryId.push(
                  res.data['mobile_action_url'].replace(/[^0-9]/gi, '')
                )
              } else if (res.data['mobile_action_url'].substring(0, 1) === 'b') {
                this.relatedTo = '2'
                this.brandId = parseInt(
                  res.data['mobile_action_url'].replace(/[^0-9]/gi, '')
                )
              } else if (res.data['mobile_action_url'].substring(0, 1) === 's') {
                this.relatedTo = '3'
              } else if (res.data['mobile_action_url'].substring(0, 1) === 'm') {
                this.relatedTo = '4'
                this.activity = res.data['mobile_action_url']
              } else if (res.data['mobile_action_url'] === 'brandList') {
                this.relatedTo = '6'
              } else {
                this.relatedTo = '5'
              }
              // console.log(this.categoryId)
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.fetchLoding = false
          })
      })
    },
    fetchUploadToken() {
      return new Promise((resolve, reject) => {
        request({
          url: '/upload-token',
          method: 'get'
        })
          .then(res => {
            this.qiniuData.token = res.data['token']
            resolve()
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    handleAvatarSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      this.hotsalesData.img = res.key

      this.img_url = 'https://img.nzmai.com.cn/' + res.key
      console.log(this.hotsalesData.img)
    },
    handleError(res) {
      // 显示错误
      console.log(res)
    },
    beforeAvatarUpload(file) {
      // 在图片提交前进行验证
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error(this.generateCustomizeString('jpgpngonly'))
      }
      if (!isLt2M) {
        this.$message.error(this.generateCustomizeString('lessThan2MB'))
      }

      return (isJPG || isPNG) && isLt2M
    },
    createHotSales() {
      var data = {}
      // if (this.relatedTo === '1') {
      data = {
        title: this.hotsalesData.title,
        mobile_action_url: this.hotsalesData.mobile_action_url,
        order_weight: parseInt(this.hotsalesData.order_weight),
        mobile_status: this.hotsalesData.mobile_status ? 1 : 0,
        is_agent_visible: this.hotsalesData.is_agent_visible ? 1 : 0,
        img: this.hotsalesData.img,
        pc_action_url: this.hotsalesData.pc_action_url,
        pc_status: this.hotsalesData.pc_status ? 1 : 0
      }
      request({
        url: 'hot-sales',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })
            this.$store.dispatch('delCurrentViews', {
              view: this.$route,
              $router: this.$router
            })
            this.$router.push({
              name: 'PcHotSales'
            })
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    },
    updateHotSales() {
      var data = {}
      // if (this.relatedTo === '1') {
      data = {
        title: this.hotsalesData.title,
        mobile_action_url: this.hotsalesData.mobile_action_url,
        order_weight: parseInt(this.hotsalesData.order_weight),
        mobile_status: this.hotsalesData.mobile_status ? 1 : 0,
        is_agent_visible: this.hotsalesData.is_agent_visible ? 1 : 0,
        img: this.hotsalesData.img,
        pc_action_url: this.hotsalesData.pc_action_url,
        pc_status: this.hotsalesData.pc_status ? 1 : 0
      }
      request({
        url: 'hot-sales/' + this.$route.params.hotSalesId,
        method: 'patch',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
            this.$router.push({
              name: 'PcHotSales'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
    }
  },
  created() {
    if (this.fetchLoding) return
    this.fetchLoding = true
    Promise.all([
      this.fetchUploadToken(),
      this.fetchCategories(),
      this.fetchBrand()
    ])
      .then(result => {
        if (this.isEdit) {
          this.fetchHotSales()
        } else {
          this.hotsalesData = Object.assign({}, defaultData)
        }
      })
      .catch(error => {
        console.warn(error)
      })
      .finally(() => {
        this.fetchLoding = false
      })
  },
  computed: {
    keyword: {
      get: function() {
        return this.hotsalesData.mobile_action_url.substr(
          this.hotsalesData.mobile_action_url.lastIndexOf('=') + 1
        )
      },
      set: function(newValue) {
        this.hotsalesData.mobile_action_url = 'search?keyword=' + newValue
        this.hotsalesData.pc_action_url = 'search?keyword=' + newValue
      }
    },
    displayHotSalesUrl() {
      return this.img_url + '?imageView2/0/w/360/h/200/q/75|imageslim'
    },
    // 查询categories
    selectedCategories: {
      // getter
      get: function() {
        const categoryId = parseInt(this.categoryId[0])
        if (categoryId) {
          var i = this.categoriesOptions.length
          while (i--) {
            const obj = this.categoriesOptions[i]
            if (obj.value === categoryId) {
              return [obj.value]
            } else {
              if (obj.children) {
                const array = obj.children
                var j = array.length
                while (j--) {
                  const cobj = array[j]
                  if (cobj.value === categoryId) {
                    return [obj.value, cobj.value]
                  }
                }
              }
            }
          }
        }
        return []
      },
      // setter
      set: function(newValue) {
        this.categoryId = [newValue[newValue.length - 1]]
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.demo-brandForm {
  padding: 50px 50px 50px 50px;
}
</style>
